import "./settings-ui.css";
import { DashboardPage, createDashboardLayout } from "../../components/DashboardPage/DashboardPage.jsx";
import { Panel } from "../../components/Panel/Panel.jsx";
import { SegmentedControl } from "../../components/SegmentedControl/SegmentedControl.jsx";
import {
  APP_LANGUAGE_ENGLISH,
  APP_LANGUAGE_HEBREW,
  APP_LANGUAGE_SYSTEM,
  APP_THEME_DARK,
  APP_THEME_INVERSE,
  APP_THEME_LIGHT,
  APP_THEME_SYSTEM
} from "../../lib/settings/appSettings.js";

const appearancePaneLayout = createDashboardLayout({
  columns: [
    { size: "fill" },
    { size: "fill" }
  ],
  rows: [
    { size: "fill" },
    { size: "fill" }
  ],
  areas: [
    ["theme", "theme"],
    ["language", "currency"]
  ]
});

export function AppearanceSettingsPane({
  theme,
  language,
  currency,
  onThemeChange,
  onLanguageChange,
  onCurrencyChange,
  t = (key) => key
}) {
  const themeOptions = [
    { value: APP_THEME_SYSTEM, label: t("system") },
    { value: APP_THEME_LIGHT, label: t("light") },
    { value: APP_THEME_DARK, label: t("dark") },
    { value: APP_THEME_INVERSE, label: t("inverse") }
  ];

  const themeNotes = {
    [APP_THEME_SYSTEM]: t("messages.appearanceSettings.themeSystem"),
    [APP_THEME_LIGHT]: t("messages.appearanceSettings.themeLight"),
    [APP_THEME_DARK]: t("messages.appearanceSettings.themeDark"),
    [APP_THEME_INVERSE]: t("messages.appearanceSettings.themeInverse")
  };

  const languageOptions = [
    {
      value: APP_LANGUAGE_SYSTEM,
      label: t("systemDefault"),
      note: t("messages.appearanceSettings.languageSystem")
    },
    {
      value: APP_LANGUAGE_ENGLISH,
      label: t("english"),
      note: t("messages.appearanceSettings.languageEnglish")
    },
    {
      value: APP_LANGUAGE_HEBREW,
      label: t("hebrew"),
      note: t("messages.appearanceSettings.languageHebrew")
    }
  ];

  const currencyOptions = [
    { value: "ILS", label: t("israeliShekelIls") },
    { value: "USD", label: t("usDollarUsd") }
  ];

  return (
    <DashboardPage
      layout={appearancePaneLayout}
      slots={[
        {
          key: "theme",
          area: "theme",
          content: (
            <Panel
              padded
              className="settings-pane--compact"
              header={t("theme")}
              footer={themeNotes[theme] ?? ""}
            >
              <SegmentedControl
                options={themeOptions}
                value={theme}
                onChange={onThemeChange}
              />
            </Panel>
          )
        },
        {
          key: "language",
          area: "language",
          content: (
            <Panel
              padded
              className="settings-pane--compact"
              header={t("language")}
              footer={languageOptions.find((option) => option.value === language)?.note ?? ""}
            >
              <div class="settings-field">
                <select
                  id="settings-language"
                  class="settings-select"
                  value={language}
                  onInput={(event) => onLanguageChange(event.currentTarget.value)}
                >
                  {languageOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
            </Panel>
          )
        },
        {
          key: "currency",
          area: "currency",
          content: (
            <Panel
              padded
              className="settings-pane--compact"
              header={t("currency")}
              footer={t("messages.appearanceSettings.currency")}
            >
              <div class="settings-field">
                <select
                  id="settings-currency"
                  class="settings-select"
                  value={currency}
                  onInput={(event) => onCurrencyChange(event.currentTarget.value)}
                >
                  {currencyOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
            </Panel>
          )
        }
      ]}
    />
  );
}
